import { z } from 'zod';
import { HOLDER_KINDS, type HolderKind } from './compliance-documents.schemas';
import { defineListQuery, listFilter } from './list-query.schemas';

/**
 * The fleet-wide compliance overview (PRD → Overview → Success measures;
 * gitaumoses4/chukua#18): an EXCEPTIONS list only — a row exists only when a
 * document is expired, expiring within 30/60 days, or missing. A document
 * valid for another year never appears here, even unfiltered.
 */

export const OVERVIEW_BUCKETS = ['expired', 'expiring_30', 'expiring_60', 'missing'] as const;
export type OverviewBucket = (typeof OVERVIEW_BUCKETS)[number];

/** `GET /compliance/overview` — search matches the holder's label (registration or driver name). */
export const complianceOverviewListQuerySchema = defineListQuery({
  sortFields: ['holderLabel', 'expiryDate', 'createdAt'],
  defaultSort: { sort: 'expiryDate', order: 'asc' },
  filters: {
    holderType: listFilter(z.enum(HOLDER_KINDS)),
    documentTypeId: listFilter(z.string().uuid()),
    bucket: listFilter(z.enum(OVERVIEW_BUCKETS)),
  },
});
export type ComplianceOverviewListQuery = z.infer<typeof complianceOverviewListQuerySchema>;

export interface ComplianceOverviewItem {
  id: string;
  holderType: HolderKind;
  holderId: string;
  holderLabel: string;
  documentTypeId: string;
  documentTypeCode: string;
  documentTypeName: string;
  expiryDate: string | null;
  bucket: OverviewBucket;
  computedAt: string;
}

/** The count tile for the future dashboard — always scoped to the caller's own visible holder types (`visibleHolderTypes`), same as the list. */
export type ComplianceOverviewCounts = Record<OverviewBucket, number>;
